export default "__VITE_ASSET__fqUpaNgO__"